import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AuthModule } from '../../auth.module';
import { BaseAuthComponent } from '../../abstract-components/base-auth.component';
import { SignupStepperComponent } from '../../components/signup-stepper/signup-stepper.component';

@Component({
  selector: 'signup-page',
  imports: [AuthModule, SignupStepperComponent],
  templateUrl: './signup-page.component.html',
  styleUrl: './signup-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignupPageComponent extends BaseAuthComponent {
  title = 'Inscription entreprise';
  description =
    'Créez votre espace sécurisé et préparez la facture normalisée électronique.';
}
